import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="13" height="13" viewBox="0 0 21 16.408"><path className="a" d="M0-11.484a.984.984,0,0,0,.984.984H15.75v1.969a.985.985,0,0,0,1.68.7l3.281-3.281a.984.984,0,0,0,0-1.392L17.43-15.79a.985.985,0,0,0-1.68.7v1.969H.984A.984.984,0,0,0,0-12.141ZM20.016-5.25H5.25V-7.219a.985.985,0,0,0-1.68-.7L.288-4.634a.984.984,0,0,0,0,1.392L3.57.04a.985.985,0,0,0,1.68-.7V-2.625H20.016A.984.984,0,0,0,21-3.609v-.656A.984.984,0,0,0,20.016-5.25Z" transform="translate(0 16.079)"/></svg>
  )
